import { FunctionComponent, useState } from 'react';
import styles from "./UserSettings.module.css";
import cn from 'classnames';
import {Image} from 'react-bootstrap';
import SidebarLayout from '../../../../../component/common/Layout/SidebarLayout/SidebarLayout';
import TextHeader from '../../../../../component/common/TextHeader/TextHeader';
import CustomButton, { ButtonRadiusSize, ButtonSize, ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
import RolesTable from './component/RolesTable/RolesTable';
import SearchInput from '../../../../../component/common/SearchInput/SearchInput';
import { ASSESTS } from '../../../../../constant/assest';
import ManageUsersTable from './component/ManageUsersTable/ManageUsersTable';
import AddUpdateRole from './component/AddUpdateRole/AddUpdateRole';
import AddUpdateUser from './component/AddUpdateUser/AddUpdateUser';

const UserSettings: FunctionComponent = () => {

    const [showUserModal, setShowUserModal] = useState<boolean>(false);
    const [showRoleModal, setShowRoleModal] = useState<boolean>(false);

    return (
        <SidebarLayout>
            <div className={cn(styles.accountsSettingPage)}>
                <div className={cn(styles.rolesSettingRow)}>
                    <div className={styles.roleHeader}>
                        <TextHeader 
                            title={'Roles'} 
                            summary={"Add New users with specific roles"}
                            className='mb-0'
                        />
                        <CustomButton
                            className={cn(styles.addBtn)}
                            btnType={ButtonType.GREEN}
                            onClick={() => {setShowRoleModal(true)}}
                            btnRadius={ButtonRadiusSize.SMALL}
                            btnSize={ButtonSize.SMALL}
                        >
                            New Role
                        </CustomButton>
                    </div>
                    <RolesTable />
                </div>
                <div className={cn(styles.usersSettingRow)}>
                    <TextHeader 
                        title={'Manage Users'} 
                        summary={"Add New users with specific roles"}
                        className='mb-4'
                    />
                    <div className={styles.manageUserHeader}>
                        <SearchInput 
                            placeholder='Search Users' 
                            className={cn(styles.manageUserSearch, 'mb-0')}
                        />
                        <CustomButton
                            className={cn(styles.addBtn)}
                            btnType={ButtonType.GREEN}
                            onClick={() => {setShowUserModal(true)}}
                            btnRadius={ButtonRadiusSize.SMALL}
                            btnSize={ButtonSize.SMALL}
                        >
                            <Image src={ASSESTS.ADDUSER} alt={'Add New User'} width={30} height={30} /> Add New User
                        </CustomButton>
                    </div>
                    <ManageUsersTable />
                </div>
            </div>
            <AddUpdateRole 
                title={'New Role'}
                showModal={showRoleModal} 
                onClose={() => setShowRoleModal(false)} 
            />
            <AddUpdateUser 
                title='Add New User'
                showModal={showUserModal} 
                onClose={() => setShowUserModal(false)} 
            />
        </SidebarLayout>
    );
};

export default UserSettings;